import { z } from 'zod';
import { ActionRef, ActionTypes } from 'further-types/lp/action';
import { isMongoId, withPaginationParams } from '../../helpers';
import { CalendarDay } from '../../../utils';
import { CurrencyCode } from 'further-types/lp/vehicle';

export const GetTransactionTypesForAction = z.object({
  actionRef: z.nativeEnum(ActionRef),
  actionType: z.nativeEnum(ActionTypes),
  customActionTypeId: z
    .string()
    .optional()
    .nullable()
    .refine(isMongoId({ optional: true }), {
      message: 'Invalid custom action type ID',
    }),
  amountIncVatTcy: z.number(),
  amountExVatTcy: z.number(),
});

export const ListActionsInput = withPaginationParams(
  z.object({
    unreconciledOnly: z.boolean().optional(),
    reconciledAndPartiallyReconciledOnly: z.boolean().optional(),
    searchQuery: z.string().optional(),
    currencies: z.array(z.nativeEnum(CurrencyCode)).optional(),
    dateRange: z
      .object({
        startDate: z.instanceof(CalendarDay),
        endDate: z.instanceof(CalendarDay),
      })
      .optional(),
  }),
  ['ledgerDate'],
);
